export default "__VITE_ASSET__11a1bb44__"